import Eye from '@assets/icons/eye.svg'
import { Icon } from './Icon'

export const EyeIcon = Icon(Eye)
